<template>
     <vs-dialog prevent-close v-model="active">
        <template #header>
          <h4 class="not-margin">
           Aplicar {{row}}
          </h4>
        </template>
        <div class="con-form">
          <vs-row>
            <vs-col vs-justify="center" vs-align="center" w="6">
              <vs-select filter label-placeholder="Nivel Académico" v-model="nivel"  :key="nivelId" :disabled="!listNivel.length" @input="onChangeNiveles">
                <template #message-danger v-if="errorFields.includes('nivel')">
                    Requerido
                </template>
                <template v-if="listNivel.length">
                    <vs-option v-for="option in listNivel" :key="option.id"  :label="option.nombre" :value="option.id">
                        {{option.nombre}}
                    </vs-option>
                </template>
                <template v-else>
                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                    </vs-option>
                </template>
              </vs-select>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" w="6">
             
              <vs-select filter label-placeholder="Programa" v-model="programa"  :key="programaId" :disabled="!listPrograma.length" ref="content">
                <template #message-danger v-if="errorFields.includes('programa')">
                    Requerido
                </template>
                <template v-if="listPrograma.length">
                    <vs-option v-for="option in listPrograma" :key="option.id"  :label="option.text" :value="option.id">
                        {{option.text}}
                    </vs-option>
                </template>
                <template v-else>
                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                    </vs-option>
                </template>
            </vs-select>
            </vs-col>
          </vs-row>
        </div>
        <template #footer>
          <div class="footer-dialog">
            <vs-button block class="color-blue" @click="getAccion(row)">
                Guardar  
            </vs-button> 
          </div>
        </template>
      </vs-dialog>
</template>

<script>
import catalogos from '../../../../api/requests/catalogos.js'
import cobranza from '../../../../api/requests/cobranza-persona.js'


export default {
    props:[
      'value',
      'row',
      'personaId',
      'cicloEscolar',
      'institucion',
      'tipo',
      'nivel',
      'nivelId',
      'listNivel',
      'programa',
      'programaId',
      'listPrograma'
    ],
    data () {
        return {
            active: false,
            descuento: false,
            conceptoDescuento: '',
            fecha: null,
            monto: null,
            montoDescuento: null,
            comentarios: null,
            autorizacion: null,
            metodoPagoId: (new Date()).getTime(),
            // programaId: (new Date()).getTime(),
            // nivelId: (new Date()).getTime(),
            conceptoId: (new Date()).getTime(),
            conceptoDescuentoId: (new Date()).getTime(),
            metodoPago: '',
            concepto: '',
            // programa: '',
            // nivel: '',
            listMetodoPago :[],
            listConceptos: [],
            noConceptos : false,
            listDescuento: [],
            // listPrograma: [],
            // listNivel: [],
            errorFields: [],
            queuePagos:[],
            metodosPago: [],
            nivelDefault: null,
            programaDefault: null
        }
    },
    methods: {
      async getAccion (type) {
          let formData = new FormData();
          formData.append("id", this.personaId),
          formData.append("ciclo_escolar", this.cicloEscolar),
          formData.append("institucion", this.institucion),
          formData.append("tipo", type)
          formData.append("programa", this.programa)
          formData.append("nivel_academico", this.nivel)
          const vm = this
              try {
                  const response = await cobranza.getInfoAccionButton(formData)
                  if(response.data.response[0].status === 200){
                      this.$vs.notification({
                          progress: 'auto',
                          color: 'success',
                          position: null,
                          title: 'Operación éxitosa'
                      })
                      vm.active = false
                      this.$emit('refreshTable')
                  }else {
                      this.$vs.notification({
                          progress: 'auto',
                          color: 'danger',
                          position: null,
                          title: 'Error',
                          text: response.data.response[0].message
                      })
                      vm.active = false
                      this.$emit('refreshTable')
                  }

              } catch (error) {
                this.$emit('endLoading');
                if (error.response.data && error.response.data.errores){
                    const data = error.response.data.errores
                    if (data.descripcion){
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: data.descripcion
                        })
                    }
                }else{
                    this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Error',
                    text: `Algo salió mal`
                    })
                }
              }
      },
      onChangeNiveles () {
          this.listPrograma = []
          this.programa = ''
          // this.getProgramas()
          this.openLoading()
      },
      // async getNivelesAcademicos () {
      //   if (this.institucion){
      //       let params = {
      //          programa: this.programa,
      //          institucion: this.institucion,
      //       }
      //     const { data: response } = await cobranza.getNivel(params) || {}
      //     const { opciones: niveles, default: val } = response || {}
      //       if (niveles){
      //           this.listNivel =  Object.values(niveles)
      //           this.nivel = val
      //           this.nivelDefault = val
      //           this.nivelId = (new Date()).getTime()
      //       }
      //   }
      // },
      // async getProgramas () {
      //   if (this.institucion){
      //     let params = {
      //       institucion: this.institucion,
      //       id: this.personaId,
      //       ciclo_escolar: this.cicloEscolar
      //     }

      //     if (this.nivel){
      //       params.nivel_academico = this.nivel
      //     }
          
      //     const { data: response } = await cobranza.getPrograma(params) || {}
      //     const { opciones: programas, default:val } = response || {}
      //       if (programas){
      //           this.listPrograma = Object.values(programas)
      //           this.programa = val
      //           this.programaDefault = val
      //           this.programaId = (new Date()).getTime()
      //       }
      //   }
      // },
      openLoading() {
        const loading = this.$vs.loading({
          target: this.$refs.content,
          color: 'dark'
        })
        setTimeout(() => {
          loading.close()
        }, 3000)
      },
      checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'date':
                  if (val && val.constructor.name === 'String' && val.trim()) {
                    const date = new Date(val)
                    if (Object.prototype.toString.call(date) === "[object Date]"){
                      if (!isNaN(date.getTime())){
                        return true
                      }
                    }
                  }
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
      },
      sanityForm () {
        let errorFields = []
        if (!this.checkByType ('number', this.programa)) {
          errorFields.push('programa')
        }  
        if (!this.checkByType ('number', this.nivel)) {
          errorFields.push('nivel')
        }  

        return errorFields
      },
      async initCatalogs() {
        if (!this.listMetodoPago.length){
          try {
              const { data: metodos } = await catalogos.getMetodosPagos()
              if (Array.isArray(metodos)){
                  this.listMetodoPago = metodos
                  this.metodoPagoId = (new Date()).getTime()
              }
          } catch (error) {
            console.log(error)
          }
        }
        if (!this.listDescuento.length){
          try {
              const { data: descuentos } = await catalogos.getDescuentos()
              if (Array.isArray(descuentos)){
                  this.listDescuento = descuentos
                  this.conceptoDescuentoId = (new Date()).getTime()
              }
          } catch (error) {
            console.log(error)
          }
        }
        // if (!this.listNivel.length){
        //   try {
        //       await this.getNivelesAcademicos()
        //   } catch (error) {
        //     console.log(error)
        //   }
        // }
        // if (!this.listPrograma.length){
        //   try {
        //       await this.getProgramas()
        //   } catch (error) {
        //     console.log(error)
        //   }
        // }
      },
    },
    watch: {
        async institucion(){
          // await this.getNivelesAcademicos()
          // await this.getProgramas()
        },
        async cicloEscolar() {
          // await this.getNivelesAcademicos()
          // await this.getProgramas()
        },
        value (val) {
            this.active = val
        },
        concepto(val){
          if (this.tipo !== 'abierto') {
              // const concepto = this.listConceptos.find(e => e.id === val)
              // if (concepto !== null){
              //   this.monto = concepto.monto_cargo
              // }
              this.getMonto()
          }
        },
        async active (val) {
            await this.initCatalogs()
            if (!val){
                this.$emit('input', val);
            }
        },
        async tipo (val) {
          this.descuento = false
          this.fecha = ''
          this.monto = ''
          this.montoDescuento = null
          this.metodoPago = ''
          this.concepto = ''
          this.queuePagos = []
          this.errorFields = []
          this.listConceptos = []
        }
    }
}
</script>

<style lang="scss"  scoped >
.color-blue {
  background-color: #005aa3;
}

.dividerLine {
  width: 100%;
  border-bottom: 1px solid #ddd
}

.greyColor {
  color: gray
}

.greyOscuro {
  color: rgb(78, 78, 78);
  font-weight: bold;
}
</style>